import { CalendarCheck, LayoutGrid, TrendingUp, Gift } from "@/lib/icons";

export const TABS = [
  { key: "today", label: "Today", Icon: CalendarCheck },
  { key: "grid", label: "Grid", Icon: LayoutGrid },
  { key: "progress", label: "Progress", Icon: TrendingUp },
  { key: "rewards", label: "Rewards", Icon: Gift },
];

export function DashboardTabs({ value, onChange, badges = {} }) {
  return (
    <nav className="sticky top-[64px] z-30 -mx-4 px-4 py-2 bg-paper/90 backdrop-blur" data-testid="dashboard-tabs">
      <div className="flex gap-1 rounded-full bg-stone-900/5 p-1 max-w-xl" role="tablist">
        {TABS.map(({ key, label, Icon }) => (
          <button key={key} role="tab" aria-selected={value === key} aria-controls={`tab-panel-${key}`} onClick={() => onChange(key)} data-testid={`tab-${key}`}
            className={`flex-1 inline-flex items-center justify-center gap-1.5 text-sm font-semibold px-3 py-2 rounded-full transition ${value === key ? "bg-stone-900 text-white shadow" : "text-stone-600 hover:text-stone-900"}`}>
            <Icon className="w-4 h-4" /> <span className="hidden sm:inline">{label}</span>
            {badges[key] > 0 && <span className={`ml-0.5 text-[10px] font-mono px-1.5 rounded-full ${value === key ? "bg-amber-400 text-stone-900" : "bg-amber-200 text-amber-900"}`} data-testid={`tab-badge-${key}`}>{badges[key]}</span>}
          </button>
        ))}
      </div>
    </nav>
  );
}
